module.exports = __webpack_public_path__ + "static/media/favicon.260e913a.ico";